<template>
  <div>
    <detalhes-fornecedor v-if="exibirDetalhesFornecedor" />
    <detalhes-produto
      v-else
      :cardSelecionado="cardSelecionado"
      @atualizarProdutos="atualizarProdutos = $event"
      :atualizarP="atualizarProdutos"
      @atualizarTelaCompras="atualizarTelaCompras = $event"
      @ocultarDetalhesProduto="ocultarDetalhesProduto = $event"
      @atualizar-produtos-total="() => $emit('atualizar-produtos-total')"
    ></detalhes-produto>
  </div>
</template>

<script>
import DetalhesProduto from "./DetalhesProduto";
import DetalhesFornecedor from "./DetalhesFornecedor";
import { mapGetters } from "vuex";
export default {
  props: ["exibirDetalhesFornecedor", 'cardSelecionado'],
  components: {
    DetalhesProduto,
    DetalhesFornecedor,
  },
  data() {
    return {
      atualizarProdutos: 0,
      ocultarDetalhesProduto: false,
      atualizarTelaCompras: {},
    };
  },
  computed: {
    ...mapGetters({
      detalhesProduto: "detalhe_produto/getProduto",
      filialCompra: "usuario/getFilialCompras",
      activityLog: "activityLog/getLog",
    }),
  },
  watch: {
    atualizarProdutos() {
      this.$emit("atualizarProdutos", this.atualizarProdutos);
    },
    atualizarTelaCompras() {
      this.$emit("atualizarTelaCompras", this.atualizarTelaCompras);
    },
    ocultarDetalhesProduto() {
      if (this.ocultarDetalhesProduto && !this.exibirDetalhesFornecedor) {
        this.$emit("ocultarDetalhesProduto", this.ocultarDetalhesProduto);
        this.ocultarDetalhesProduto = false;
      }
    },
    activityLog() {
      const FUNCTION = this.activityLog.function;

      // para refazer atividade com funcao em detalhesProduto.vue
      // adicione o nome da funcao no array abaixo
      const funcoesDetalhesProduto = [
        "getSimilaresGrupo",
        "getDetalhamentoEstoqueGrupo",
      ];

      if (funcoesDetalhesProduto.includes(FUNCTION)) {
        this.ocultarDetalhesProduto = false;
        this.$emit("detalhesFornecedor", false);
      } else if (typeof this[FUNCTION] == "function") {
        this[FUNCTION]();
      }
    },
  },
  methods: {
    getMovimentacoesGrupos() {
      // ATIVAR DETALHES DO FORNECEDOR
      this.ocultarDetalhesProduto = true;
    },
  },
};
</script>

<style>
.altura-responsiva-fornecedor-produto {
  overflow: hidden !important;
}
.altura-responsiva-fornecedor-produto {
  height: calc(100vh - 114px) !important;
}
</style>
<style>
/*
 **   ALTURA DINAMICA EM DIFERENTES TAMANHOS DE TELAS
 */
@media (max-height: 10000px) {
  .altura-responsiva-chart-produto {
    height: 610px;
  }
  .altura-responsiva-chart-fornecedor {
    height: 40vh;
  }
}
@media (max-height: 1040px) {
  .altura-responsiva-chart-produto {
    height: 585px;
  }
  .altura-responsiva-chart-fornecedor {
    height: 40vh;
  }
}
@media (max-height: 975px) {
  .altura-responsiva-chart-produto {
    height: 560px !important;
  }
}
@media (max-height: 950px) {
  .altura-responsiva-chart-produto {
    height: 535px;
  }
  .altura-responsiva-chart-fornecedor {
    height: 40vh;
  }
}
@media (max-height: 925px) {
  .altura-responsiva-chart-produto {
    height: 510px !important;
  }
}
@media (max-height: 900px) {
  .altura-responsiva-chart-produto {
    height: 485px;
  }
  .altura-responsiva-chart-fornecedor {
    height: 40vh;
  }
}
@media (max-height: 875px) {
  .altura-responsiva-chart-produto {
    height: 460px !important;
  }
}
@media (max-height: 850px) {
  .altura-responsiva-chart-produto {
    height: 435px;
  }
  .altura-responsiva-chart-fornecedor {
    height: 40vh;
  }
}
@media (max-height: 825px) {
  .altura-responsiva-chart-produto {
    height: 310px !important;
  }
}
@media (max-height: 800px) {
  .altura-responsiva-chart-produto {
    height: 385px !important;
  }
  .altura-responsiva-chart-fornecedor {
    height: 40vh !important;
  }
}
@media (max-height: 775px) {
  .altura-responsiva-chart-produto {
    height: 365px !important;
  }
}
@media (max-height: 750px) {
  .altura-responsiva-chart-produto {
    height: 340px !important;
  }
}
@media (max-height: 725px) {
  .altura-responsiva-chart-produto {
    height: 315px !important;
  }
  .altura-responsiva-chart-fornecedor {
    height: 39vh !important;
  }
}
@media (max-height: 700px) {
  .altura-responsiva-chart-produto {
    height: 290px !important;
  }
  .altura-responsiva-chart-fornecedor {
    height: 38vh !important;
  }
}
@media (max-height: 680px) {
  .altura-responsiva-chart-produto {
    height: 265px !important;
  }
}
@media (max-height: 650px) {
  .altura-responsiva-chart-produto {
    height: 240px !important;
  }
}
@media (max-height: 625px) {
  .altura-responsiva-chart-produto {
    height: 215px !important;
  }
}
@media (max-height: 600px) {
  .altura-responsiva-chart-produto {
    height: 200px !important;
  }
}
@media (max-height: 580px) {
  .altura-responsiva-chart-produto {
    height: 160px !important;
  }
}
</style>
